let $megamenu = document.querySelector('.megamenu')
let $toggler = document.querySelector('.sticky__toggle')

if($megamenu) {
	$megamenu.addEventListener("scroll", function() {
		let scroll = $megamenu.scrollTop

		$toggler.style.transform = "translate(0, -"+scroll+"px)"
	});
}
